import React from 'react'
import BookButton from '../Shared/BookButton.js'
import become from '../../img/become.png'


export default function BecomeCounselor() {
    return (
        <div className='grid md:grid-cols-2 m-10'>
            <div className=' px-10 my-14'>
                <h2 className='md:text-4xl text-3xl font-bold mb-10'>Your <span className='text-sky-700'>best</span> course of action to
                    <span className='text-orange-600'>become a counselor </span>starts right
                    now.</h2>
                <p className='text-xl font-semibold'>
                    Our mission is to improve the lives of students by
                    offering them the greatest career guidance and
                    recommendations.
                </p>
                <div className='grid md:grid-cols-2'>
                    <a className='' href="https://forms.gle/9DNjhNYJrHVAzVVL6" rel="noreferrer" target="_blank"><BookButton name='Become a Counselor' /></a>
                    <a className='' href="https://forms.gle/9DNjhNYJrHVAzVVL6" rel="noreferrer" target="_blank"><BookButton name='Be a Live Q/A Solver' /></a>
                </div>
            </div>
            <div>
                <img src={become} className='md:w-30' alt='' />
            </div>
        </div>
    )
}
